import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0dfd70da"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "container"
};
const _hoisted_2 = ["src"];
const _hoisted_3 = {
  key: 0,
  class: "introduction"
};
const _hoisted_4 = {
  class: "w"
};
const _hoisted_5 = {
  class: "left"
};
const _hoisted_6 = {
  class: "title"
};
const _hoisted_7 = {
  class: "desc"
};
const _hoisted_8 = ["innerHTML"];
const _hoisted_9 = {
  class: "create-year"
};
const _hoisted_10 = {
  class: "item-number",
  style: {
    "color": "#432885"
  }
};
const _hoisted_11 = {
  class: "item-unit",
  style: {
    "color": "#1d2129"
  }
};
const _hoisted_12 = {
  class: "item-name"
};
const _hoisted_13 = ["src"];
const _hoisted_14 = {
  key: 0,
  class: "module"
};
const _hoisted_15 = {
  class: "w"
};
const _hoisted_16 = {
  class: "main-title"
};
const _hoisted_17 = {
  class: "teacher-list"
};
const _hoisted_18 = {
  key: 1,
  class: "module"
};
const _hoisted_19 = {
  class: "w"
};
const _hoisted_20 = {
  class: "main-title"
};
const _hoisted_21 = {
  key: 0,
  class: "content"
};
const _hoisted_22 = {
  class: "left-img"
};
const _hoisted_23 = {
  class: "image-slot"
};
const _hoisted_24 = {
  class: "image-slot"
};
const _hoisted_25 = {
  class: "right-box"
};
const _hoisted_26 = ["onClick"];
const _hoisted_27 = {
  class: "index"
};
const _hoisted_28 = {
  class: "title"
};
const _hoisted_29 = ["innerHTML"];
import Card from './Card.vue';
import { getCurrentInstance } from 'vue';
import { getContentText } from '@/plugins/utils';
import { Picture as IconPicture } from '@element-plus/icons-vue';
export default {
  props: {
    classList: {
      type: Array,
      default: () => []
    },
    menuId: {
      type: String,
      default: ''
    },
    data: {
      type: Array,
      default: () => []
    },
    menuInfo: {
      type: Object,
      default: () => {}
    }
  },
  emits: ['goDetails'],

  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const descTextRef = ref(null);
    const {
      appContext
    } = getCurrentInstance();
    const positionTop = ref(0);
    const defaultCoverImg = inject('defaultImg');
    const classData = computed(() => {
      const newList = props.classList.filter(item => item.name !== '医院简介');
      return newList;
    });
    const topNews = computed(() => {
      return props.data.find(item => item.classify_name === '医院简介') || {};
    });
    const createYear = [{
      number: 1949,
      unit: '年',
      name: '始建于'
    }, {
      number: 54,
      unit: '个',
      name: '临床科室'
    }];

    const getNewsClassList = (id, num = 4) => {
      const newsClassList = props.data.filter(item => item.classify_id === id).slice(0, num);
      return newsClassList || [];
    };

    const goDetails = item => {
      emits('goDetails', item);
    };

    const textOverFlow = () => {
      const text = descTextRef.value.innerText;
      const newText = text.substring(0, 215) + '...';
      descTextRef.value.innerText = newText;
      console.log(descTextRef.value.clientHeight);
      positionTop.value = descTextRef.value.clientHeight - 35;
    };

    onMounted(() => {
      nextTick(() => {
        textOverFlow();
      });
    });
    return (_ctx, _cache) => {
      const _component_el_icon = _resolveComponent("el-icon");

      const _component_el_image = _resolveComponent("el-image");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("img", {
        class: "banner",
        src: __props.menuInfo.backgroundImag || _unref(defaultCoverImg),
        alt: ""
      }, null, 8, _hoisted_2), _unref(topNews).news_name ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(_unref(topNews).news_name), 1), _createElementVNode("div", _hoisted_7, [_unref(topNews).context ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        ref_key: "descTextRef",
        ref: descTextRef,
        class: "text",
        innerHTML: _unref(getContentText)(_unref(topNews).context)
      }, null, 8, _hoisted_8)) : _createCommentVNode("", true), _unref(topNews).context ? (_openBlock(), _createElementBlock("span", {
        key: 1,
        class: "view-more",
        style: _normalizeStyle({
          top: positionTop.value + 'px'
        }),
        onClick: _cache[0] || (_cache[0] = $event => goDetails(_unref(topNews)))
      }, " 查看全文>> ", 4)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_9, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(createYear, (item, index) => {
        return _createElementVNode("div", {
          key: index,
          class: "item"
        }, [_createElementVNode("span", _hoisted_10, [_createTextVNode(_toDisplayString(item.number) + " ", 1), _createElementVNode("span", _hoisted_11, _toDisplayString(item.unit), 1)]), _createElementVNode("span", _hoisted_12, _toDisplayString(item.name), 1)]);
      }), 64))])]), _createElementVNode("img", {
        class: "right",
        src: _unref(topNews).cover_url || _unref(defaultCoverImg),
        alt: ""
      }, null, 8, _hoisted_13)])])) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(classData), (item, index) => {
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.id
        }, [index % 2 === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_17, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNewsClassList(item.id), item => {
          return _openBlock(), _createBlock(Card, {
            key: item.id,
            teacherData: item,
            onClick: $event => goDetails(item)
          }, null, 8, ["teacherData", "onClick"]);
        }), 128))])])])) : (_openBlock(), _createElementBlock("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, _toDisplayString(item.name), 1), getNewsClassList(item.id).length ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", _hoisted_22, [_createVNode(_component_el_image, {
          class: "img",
          src: getNewsClassList(item.id)[0].cover_url || _unref(defaultCoverImg)
        }, {
          error: _withCtx(() => [_createElementVNode("div", _hoisted_23, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(IconPicture))]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["src"]), getNewsClassList(item.id).length >= 3 ? (_openBlock(), _createBlock(_component_el_image, {
          key: 0,
          class: "img",
          src: getNewsClassList(item.id)[2].cover_url || _unref(defaultCoverImg)
        }, {
          error: _withCtx(() => [_createElementVNode("div", _hoisted_24, [_createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(IconPicture))]),
            _: 1
          })])]),
          _: 2
        }, 1032, ["src"])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_25, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getNewsClassList(item.id), (item, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: item.index,
            class: "item",
            style: _normalizeStyle({
              'border-right': index === 1 || index === 3 ? 'none' : '',
              'border-top': index === 2 || index === 3 ? 'none' : ''
            }),
            onClick: $event => goDetails(item)
          }, [_createElementVNode("span", _hoisted_27, _toDisplayString(`0${index + 1}.`), 1), _createElementVNode("span", _hoisted_28, _toDisplayString(item.news_name), 1), _createElementVNode("div", {
            innerHTML: _unref(getContentText)(item.context),
            class: "desc"
          }, null, 8, _hoisted_29)], 12, _hoisted_26);
        }), 128))])])) : _createCommentVNode("", true)])]))], 64);
      }), 128))]);
    };
  }

};